import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

const ConventionalPOR = () => {
  return (
    <>
      <Helmet>
        <title>Conventional Proof of Reserves - Proof of Reserves Auditor</title>
        <meta name="description" content="Traditional attestation-based proof of reserves audits by CPA-certified auditors." />
      </Helmet>

      <div className="service-page">
        <section className="relative section-padding bg-gradient-to-br from-primary to-primary-800 text-white">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="/cpaservices.jpg"
              alt="CPA Services Background"
              className="w-full h-full object-cover"
            />
            {/* Dark overlay for text readability */}
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          </div>
          <div className="container-custom relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Conventional Proof of Reserves</h1>
            <p className="text-xl text-gray-200 max-w-3xl">
              Traditional attestation-based audit methodology providing independent verification of your reserves
            </p>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="container-custom max-w-4xl">
            <h2 className="section-title">Overview</h2>
            <p className="text-lg text-gray-600 mb-6">
              Our CPA-certified auditors perform comprehensive analysis of wallet holdings and liability records, delivering formal attestation reports recognized by regulators and stakeholders.
            </p>

            <h2 className="section-title mt-12">Key Features</h2>
            <ul className="list-disc list-inside text-lg text-gray-600 space-y-2 mb-8">
              <li>CPA-certified audit team</li>
              <li>Regulatory-compliant reports</li>
              <li>Comprehensive wallet verification</li>
              <li>Liability reconciliation</li>
              <li>Industry-standard methodologies</li>
            </ul>

            <div className="mt-12 text-center">
              <Link to="/contact" className="btn-primary">
                Request a Quote
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default ConventionalPOR